import { URL_UPDATE_USER_API } from 'constants/urls';

async function updateUserApi(user) {
	const options = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json;charset=UTF-8' },
		body: JSON.stringify({ payload: user }),
	};

	const res = await fetch(URL_UPDATE_USER_API, options);

	if (!res.ok) {
		const message = `HTTP error! status: ${res.status}`;
		throw new Error(message);
	}

	const data = await res.json();

	if (!data.Success) {
		const message = data.Message;
		throw new Error(message);
	}

	return data;
}

export default updateUserApi;
